/* eslint-disable @typescript-eslint/no-var-requires */
import { Dialog } from "@mui/material";
import React from "react";

import ReassignmentSection from "./reassignment-section";

interface ReassignmentDialogProps {
	open: boolean;
	workerFullName: string;
	shiftDetails: {
		shiftPatternName: string;
		endDateTime: string;
		startDateTime: string;
	};
	onConfirm: (selectedJobWC: { jobId: number; workCenterId: number }) => void;
	onCancel: () => void;
}

const ReassignmentDialog: React.FC<ReassignmentDialogProps> = ({
	open,
	workerFullName,
	shiftDetails,
	onConfirm,
	onCancel,
}) => {
	return (
		<Dialog
			open={open}
			onClose={onCancel}
			maxWidth='md'
			fullWidth
			aria-labelledby='reassignment-dialog-title'
		>
			<ReassignmentSection
				workerFullName={workerFullName}
				shiftDetails={shiftDetails}
				onConfirm={onConfirm}
				onCancel={onCancel}
			/>
		</Dialog>
	);
};

export default ReassignmentDialog;
